import { useState } from "react";
import { MessageOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PopUp from "../../shared-ui-components/PopUp";
import ReportForm from "../../shared-ui-components/ReportForm";

const BugReportButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button
        type="default"
        onClick={() => setIsOpen(true)}
        icon={<MessageOutlined />}
        className="feedback-button"
        title="Give us feedback"
      />
      <PopUp openModal={isOpen} setOpenModal={setIsOpen} fullWidth={0}>
        <ReportForm setOpenModal={setIsOpen} feedbackMode />
      </PopUp>
    </>
  );
};

export default BugReportButton;
